// Live-updates the "¿Qué recibirás?" block when the shopper changes a
// variant option, by reading the currently checked variant radio values
// directly (no dependency on the theme's internal section-morph timing).
(function () {
  function getSelectedOptionValues() {
    var values = [];
    document.querySelectorAll('.variant-option input[type="radio"]:checked').forEach(function (input) {
      values.push(input.value);
    });
    // Single-select variant pickers (dropdown) fall back to <select> elements.
    document.querySelectorAll('.variant-option select').forEach(function (select) {
      if (select.value) values.push(select.value);
    });
    return values;
  }

  function updateWyg(root) {
    var selected = getSelectedOptionValues();
    var cases = root.querySelectorAll('[data-squishy-wyg-case]');
    var matched = null;
    var fallback = null;

    cases.forEach(function (caseEl) {
      var match = caseEl.getAttribute('data-match');
      if (match) {
        if (selected.indexOf(match) !== -1) matched = caseEl;
      } else {
        fallback = caseEl;
      }
    });

    var toShow = matched || fallback;

    cases.forEach(function (caseEl) {
      var shouldShow = caseEl === toShow;
      caseEl.classList.toggle('is-active', shouldShow);
      if (shouldShow) {
        caseEl.removeAttribute('hidden');
      } else {
        caseEl.setAttribute('hidden', '');
      }
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-squishy-wyg]');
    if (!roots.length) return;

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !(target.closest('.variant-option'))) return;
      roots.forEach(updateWyg);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
